import controller from './notes.controller';

const template = require('./notes.html');

export default {
    bindings: {
        thingId: '<'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/notes/notes.component.js